/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BusinessList } from './BusinessList';
import {
    BusinessListFromJSON,
    BusinessListFromJSONTyped,
    BusinessListToJSON,
} from './BusinessList';

/**
 * 
 * @export
 * @interface PaginatedBusinessListList
 */
export interface PaginatedBusinessListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedBusinessListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBusinessListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBusinessListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<BusinessList>}
     * @memberof PaginatedBusinessListList
     */
    results: Array<BusinessList>;
}

/**
 * Check if a given object implements the PaginatedBusinessListList interface.
 */
export function instanceOfPaginatedBusinessListList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PaginatedBusinessListListFromJSON(json: any): PaginatedBusinessListList {
    return PaginatedBusinessListListFromJSONTyped(json, false);
}

export function PaginatedBusinessListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedBusinessListList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(BusinessListFromJSON)),
    };
}

export function PaginatedBusinessListListToJSON(value?: PaginatedBusinessListList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(BusinessListToJSON)),
    };
}

